import { inject } from '@angular/core';
import { CanActivateFn, UrlTree, Router } from '@angular/router';
import { map, Observable } from 'rxjs';

import { MODULE_ROUTES } from '@common/constants/module-routes.const';
import { PhxConstants } from '@common/PhoenixCommon.module';
import { AuthService } from '@common/services/auth.service';

export const loginRedirectGuard: CanActivateFn = (): Observable<UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.getCurrentProfile().pipe(
    map(currentProfile => {
      if (currentProfile.ProfileTypeId === PhxConstants.UserProfileType.Internal) {
        return router.createUrlTree([`/next/${MODULE_ROUTES.ACCOUNT}/${MODULE_ROUTES.HOME}`]);
      } else {
        return router.createUrlTree([`/next/${MODULE_ROUTES.ACTIVITY_CENTRE}`]);
      }
    })
  );
};
